import MenuItemCotizacion from '@/components/MenuItemCotizacion.vue';

export const headers = [
  {
    headerName: 'Nº Cotización',
    field: 'id',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    sort: 'desc',
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Razón Social',
    field: 'razon_social',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Rut',
    field: 'rut_cliente',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Ejecutivo',
    field: 'ejecutivo',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Fecha Creación',
    field: 'fecha_creacion',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Estado',
    field: 'estado',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Soluciones',
    field: 'soluciones',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Pdf',
    field: 'url_pdf',
    sortable: false,
    resizable: true,
    minWidth: 80,
    hide: true,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Acciones',
    width: 120,
    minWidth: 120,
    sortable: false,
    resizable: false,
    filter: false,
    enablePivot: false,
    field: 'id',
    cellRendererFramework: MenuItemCotizacion,
    cellRendererParams: (params: any) => {
      return {
        data: params.data,
        typeModal: 'cotizacion',
      };
    },
    colId: 'params',
    rowDrag: false,
    pinned: 'right',
    lockVisible: true,
    suppressMovable: true,
    getQuickFilterText: () => '',
  },
];
